import { Layout } from 'components/widgets';
import { SavedAlertsAll } from 'components/containers';
import { usePathIndicator } from 'hooks';
import { LINKS } from 'utils/constants';

const SavedAlertsPage = () => {
  usePathIndicator([LINKS.saved, LINKS.savedAll]);

  return (
    <Layout>
      <SavedAlertsAll />
    </Layout>
  );
};

export default SavedAlertsPage;
